import { Box, Button, Grid } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getRoleClaimsSelector } from "../../store/auth/selectors";
import OverrideRequestsExplorer from "../../components/organisms/overrideRequestsExplorer/OverrideRequestsExplorer";

const OverrideRequestList = () => {

    const navigate = useNavigate();

    const addOverrideRequest = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = "/NewOverrideRequest";
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }
    }

    const roles = useSelector(getRoleClaimsSelector);  // roles  - IDP.Admin or IDP.User

    const [isAdmin, setIsAdmin] = useState(true);
    useEffect(() => {
        if (roles && roles.length > 0) {
            setIsAdmin(roles.includes("IDP.Admin") ? true : false);
        }
    }, [roles]);

    return (
        <>
            <Box sx={{ paddingBottom: "10px" }}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                    <Grid item xs={8}>
                        <h1 style={{ textAlign: "left" }}>Override Requests</h1>
                    </Grid>
                    <Grid item xs={4} style={{ textAlign: "right" }}>
                        <Button id="70050857-3e95-468e-8fe3-84c5545b4bb0" color="primary" variant="contained" onClick={addOverrideRequest} endIcon={<AddIcon />}>
                            Request New Override
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <OverrideRequestsExplorer isAdmin={isAdmin}/>
        </>
    )
}

export default OverrideRequestList;